// @flow

import { AppIntegrationState, AppIntegrationAction } from 'stores/flow-type/app-integration.type';

import {
  HANDLE_CHANGE_SWITCH_APP,
  HANDLE_CONTINUE_SWITCH_APP_REQUEST,
  HANDLE_CONTINUE_SWITCH_APP_SUCCESS,
  HANDLE_CONTINUE_SWITCH_APP_FAILURE,
  HANDLE_CHANGE_REMOVE_APP,
  HANDLE_CONTINUE_REMOVE_APP_REQUEST,
  HANDLE_CONTINUE_REMOVE_APP_SUCCESS,
  HANDLE_CONTINUE_REMOVE_APP_FAILURE,
  HANDLE_REVIEWS_IO_ATTR_SUCCESS,
  MARK_OPEN_FULLSCREEN
} from 'stores/flow-type/app-integration.type';

const initialState: AppIntegrationState = {
  // Handle change Switch app modal
  switchAppModalActive: false,
  switchAppType: '',
  switchAppName: '',
  switchAppKey: '',

  // Remove app
  removeAppLoading: false,
  removeAppSuccess: false,

  // Switch app
  switchAppLoading: false,
  switchAppSuccess: false,

  // Handle change Remove app modal
  removeAppModalActive: false,
  removeAppType: '',
  removeAppName: '',

  // Flag check open fullscreen
  openFullscreen: false,

  loading: false,
  success: false,
  error: undefined,
  reviewsIoAttrData: {}
};

const appIntegrationReducers = (
  state: AppIntegrationState = initialState,
  action: AppIntegrationAction
) => {
  const { meta = {} } = action;
  const { appName, appType, appKey } = meta;

  switch (action.type) {
    // Handle change modal remove app
    case HANDLE_CHANGE_SWITCH_APP: {
      const { switchAppModalActive } = state;

      return {
        ...state,
        switchAppModalActive: !switchAppModalActive,
        switchAppType: appType,
        switchAppName: appName,
        switchAppKey: appKey
      };
    }

    case HANDLE_CONTINUE_SWITCH_APP_REQUEST:
      return { ...state, switchAppLoading: true, switchAppSuccess: false };

    case HANDLE_CONTINUE_SWITCH_APP_SUCCESS: {
      return {
        ...state,
        switchAppModalActive: false, // Close modal
        switchAppLoading: false,
        switchAppSuccess: true,
        error: undefined
      };
    }
    case HANDLE_CONTINUE_SWITCH_APP_FAILURE:
      return {
        ...state,
        switchAppLoading: false,
        switchAppSuccess: false,
        error: action.payload
      };

    // Handle change modal remove app
    case HANDLE_CHANGE_REMOVE_APP: {
      const { removeAppModalActive } = state;

      return {
        ...state,
        removeAppModalActive: !removeAppModalActive,
        removeAppType: appType,
        removeAppName: appName
      };
    }

    // Handle continue action for removing app
    case HANDLE_CONTINUE_REMOVE_APP_REQUEST:
      return { ...state, removeAppLoading: true, removeAppSuccess: false };

    case HANDLE_CONTINUE_REMOVE_APP_SUCCESS: {
      return {
        ...state,
        removeAppModalActive: false, // Close modal
        removeAppLoading: false,
        removeAppSuccess: true,
        error: undefined
      };
    }
    case HANDLE_CONTINUE_REMOVE_APP_FAILURE:
      return {
        ...state,
        removeAppLoading: false,
        removeAppSuccess: false,
        error: action.payload
      };
    case HANDLE_REVIEWS_IO_ATTR_SUCCESS:
      return {
        ...state,
        reviewsIoAttrData: action.payload.data
      };

    case MARK_OPEN_FULLSCREEN:
      return {
        ...state,
        openFullscreen: action.payload
      };
    default:
      return state;
  }
};

export default appIntegrationReducers;
